import { render } from "./billets.vue?vue&type=template&id=1b9e0df9"
import script from "./billets.vue?vue&type=script&lang=js"
export * from "./billets.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__